<template>
  <li class="list-item">
    <div class="inner">
      <NuxtLink :to="props.link" class="list-link">
        <div class="text-wrap">
          <div class="the-press">
            <p class="media" v-html="props.media" />
            <p class="date" v-html="formatIntlDate(new Date(props.date), locale) " />
          </div>
          <div class="texts">
            <h3 class="title" v-html="props.title" />
            <p class="desc" v-html="props.desc" />
          </div>
        </div>
        <div class="btn-press" v-html="$t('기사보기')" />
      </NuxtLink>
      <div class="additional">
        <img :src="props.image" alt="">
        <div class="texts">
          <div
            class="summary"
            v-html="props.summary"
          />
          <div class="tags">
            <span v-for="tag in props.tags" :key="tag" v-html="tag" />
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script lang="ts" setup>
const props = defineProps<{
  link: string
  media: string
  date: string
  title: string
  image: string
  summary: string
  desc: string
  tags: string[]
}>()

const { locale } = useI18n()
</script>
